import { InjectionToken } from '@angular/core';
import { environment } from '../../../environments/environment';

export interface EtsConfig {
  addFiscalDraft: boolean;
  addNiTables: boolean;
  addFinancial: boolean;
  addEditor: boolean;
  addDeposit: boolean;
  addModefinance: boolean;
  showPartitario: boolean;
}

export const etsConfig: EtsConfig = {
  ...environment.etsConf,
};

export const ETS_CONFIG = new InjectionToken<EtsConfig>('etsConfig');
